export { default } from './LazySkillXP';
